import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { LOGO_URL, CONTACT_EMAIL, LOCATION } from "@/lib/site";
import { useBooking } from "@/components/BookingProvider";

const Footer = () => {
  const { openBooking } = useBooking();
  return (
    <footer data-testid="footer" className="bg-white text-ink border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Cultural Capital" className="h-9 w-auto" />
              <span className="font-serif text-xl text-ink">Cultural Capital</span>
            </div>
            <p className="text-sm text-[#64748B]">
              © 2026 Cultural Capital Analytics Inc. All rights reserved.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-[#94A3B8] mb-5">Navigate</p>
            <ul className="space-y-3 text-[#475569]">
              <li><Link to="/" className="hover:text-ink transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-ink transition-colors">About</Link></li>
              <li><Link to="/owners" className="hover:text-ink transition-colors">For Owners (Sell-Side)</Link></li>
              <li><Link to="/buyers" className="hover:text-ink transition-colors">For Buyers (Buy-Side)</Link></li>
              <li><Link to="/workshops" className="hover:text-ink transition-colors">Workshops</Link></li>
              <li><Link to="/contact" className="hover:text-ink transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-[#94A3B8] mb-5">Contact</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-3 text-[#475569] hover:text-ink transition-colors mb-3">
              <Mail className="w-4 h-4 text-brand" /> {CONTACT_EMAIL}
            </a>
            <p className="flex items-center gap-3 text-[#475569] mb-6">
              <MapPin className="w-4 h-4 text-brand" /> {LOCATION}
            </p>
            <button
              onClick={openBooking}
              className="inline-flex items-center gap-2 border border-[#CBD5E1] text-ink px-5 py-2.5 text-sm font-medium hover:bg-ink hover:text-white hover:border-ink transition-colors"
            >
              Book Strategy Call
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
